import React from 'react';

const KeywordHints = ({ KeywordMessage }) => {
  if (!KeywordMessage) return null;
  return (
    <div className="keyword-hints">
      <div className="c-keyword__icon-container">
        <i className="c-keyword__icon" />
      </div>
      <div dangerouslySetInnerHTML={{ __html: KeywordMessage }}></div>
    </div>
  );
};

export default KeywordHints;
